import { Instance, types } from "mobx-state-tree";
import { ChatNotification } from "./ChatNotification";
export enum NotificationType {
  HighPriority,
  NoConnection,
  ChatProfanity,
  ChatMessageLength,
  LowPriority
}

export enum NotificationLevel {
  Error,
  Warning
}

export type Callback = () => void;

export interface ChatNotificationParams {
  readonly message: string;
  readonly type?: NotificationType;
  readonly level?: NotificationLevel;
  readonly onCancel?: Callback;
  readonly onAction?: Callback;
  readonly actionText?: string;
  readonly isDismissDisabled?: boolean;
}

export const ChatNotificationStore = types
  .model("ChatNotificationStore", {
    chatNotification: types.maybe(ChatNotification)
  })
  .actions((self) => {
    const isNotificationLessImportant = (params: ChatNotificationParams): boolean => {
      return !!self.chatNotification && !!params.type && params.type < self.chatNotification.type;
    };

    const actions = {
      /**
       * Notification to be displayed above chat, defaults to error with type low priority. If another is
       * already displayed overrides if priority has lower value
       */
      setChatNotification(params: ChatNotificationParams) {
        if (isNotificationLessImportant(params)) {
          return;
        }

        const { onAction, onCancel, type, level, ...rest } = params;
        const notification = ChatNotification.create({
          type: type || NotificationType.LowPriority,
          level: level || NotificationLevel.Error,
          ...rest
        });

        if (onAction) {
          notification.setOnAction(onAction);
        }
        if (onCancel) {
          notification.setOnCancel(onCancel);
        }

        self.chatNotification = notification;
      },

      removeChatNotification() {
        self.chatNotification = undefined;
      },

      removeChatNotificationIfType(type: NotificationType) {
        if (self.chatNotification && self.chatNotification.type === type) {
          self.chatNotification = undefined;
        }
      }
    };

    return actions;
  });

export interface IChatNotifcationStore extends Instance<typeof ChatNotificationStore> {}
